export const statusLabels = {
  da_fare: "Da fare",
  in_corso: "In corso",
  completata: "Completata",
};

export const statusColors = {
  da_fare: "bg-zinc-700/50 text-zinc-300",
  in_corso: "bg-[#007AFF]/15 text-[#007AFF]",
  completata: "bg-[#34C759]/15 text-[#34C759]",
};

export const metricOptions = [
  { key: "weight_kg", label: "Peso (kg)", color: "#007AFF" },
  { key: "body_fat_pct", label: "% Grasso", color: "#D4FF00" },
  { key: "chest_cm", label: "Petto", color: "#34C759" },
  { key: "waist_cm", label: "Vita", color: "#FF3B30" },
  { key: "hips_cm", label: "Fianchi", color: "#FF9500" },
  { key: "biceps_cm", label: "Bicipiti", color: "#AF52DE" },
  { key: "thighs_cm", label: "Cosce", color: "#5AC8FA" },
  { key: "shoulders_cm", label: "Spalle", color: "#FFD60A" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
